import React from 'react';
import AssessmentCard from '../../utils/components/assesstmentCard';
import {motion} from 'framer-motion';
import { struggle_intense_internal_domains } from '../../../../utils/vision_wheel';
import { connect } from 'react-redux';
import { RootState } from '../../../../db/redux/store';



class InnerSelfAssesstment extends React.PureComponent<any,any>{
    selected: any;
    constructor(props:any) {
        super(props);
        this.selected = {
            ...this.props.rate
        }
    };

    _next = () => {
        return {
            go: true,
            value:{
                ...this.selected
            }
        };
    };


    _on_impact_change = (id:string,impact:string) => {
        this.selected[id] = {
            ...this.selected[id],
            impact
        }
    };

    _on_rate_change = (id:string,rate:number) => {
        this.selected[id] = {
            ...this.selected[id],
            rate
        }
    };

    _render_lists = (item:typeof struggle_intense_internal_domains[0]) => {
        return <AssessmentCard dynamic defaultImpact={this.props.rate[item.id]?.impact} defaultRate={this.props.rate[item.id]?.rate} onImpactChange={this._on_impact_change} onRateChange={this._on_rate_change} key={item.id} {...item}/>
    };
    render(): React.ReactNode {
        

    return (
        <div className="w-full h-full flex px-4 py-6 flex-col overflow-scroll action_container pb-96">
                <span className="font-quick text-text text-[16px] leading-[20px] flex mb-4 font-semibold">Assessing the Impact (Inner Self)</span>
                <span className='font-quick text-title text-[13px] leading-[16px] font-medium'>Now that you have rated the sustainability of your situation, let’s better understand the impact in every area of your inner self.</span>
                <motion.div layout className='space-y-2 flex flex-col pt-[22px]'>
                    {struggle_intense_internal_domains.map(this._render_lists)}
                </motion.div>
        </div>
    );
    }
};

const map_state_to_props = (state:RootState) => {
    return {
        rate:{
            ...state.app['circgen_vision_wheel_internal']
        }
    }
};

export default connect(map_state_to_props,null,null,{forwardRef:true})(InnerSelfAssesstment);